export default {
  login: {
    title: 'Logowanie',
    subtitle: 'Możesz się zalogować przy użyciu danych konta z aplikacji ',
    password: 'Hasło',
    login: 'Zaloguj',
    registerLink: 'Nie masz konta? Zarejestruj się!',
    resetPasswordLink: 'Zapomniałeś hasła?',
    animalkiApp: 'Animalki',
  },
  validates: {
    requiredField: 'Wymagane pole',
    emailNotValid: 'Niepoprawny adres e-mail',
    minLength: 'To pole powinno zawierać 15 znaków',
    phoneNumber: 'Wpisz poprawny numer telefonu',
    passwordLength: 'Hasło musi mieć długość od 3 do 16 znaków',
    repeatPassword: 'Hasła muszą być takie same',
    chooseVisitTime: 'Wybierz termin wizyty',
  },
  alerts: {
    loginError: 'Nie udało się zalogować użytkownika',
    getPetsError: 'Nie udało się załadować listy zwierząt',
    createPetSuccess: 'Zwierzak został dodany pomyślnie',
    createPetError: 'Nie udało się dodać zwierzaka',
    updatePetSuccess: 'Informacje o zwierzaku zostały zaaktualizowane',
    updatePetError: 'Nie udało się zaaktualizować informacji o zwierzaku',
    deletePetSuccess: 'Zwierzak został usunięty pomyślnie',
    deletePetError: 'Nie udało się usunąć zwierzaka',
    saveProfileError: 'Nie udało się zapisać profilu użytkownika',
    saveProfileSuccess: 'Dane profilu użytkownika zostały zapisane pomyślnie',
    registerError: 'Podczas rejestracji wystąpił błąd. Spróbuj ponownie.',
    registerSuccess: 'Rejestracja przebiegła pomyślnie. Na podany adres email została wysłana wiadomość potwierdzająca.',
    resetPasswordSuccess: 'Hasło zostało zresetowane. Sprawdź swoją skrzynkę email',
    resetPasswordError: 'Nie udało się zresetować hasła. Sprawdź poprawność adresu email',
    getVisitTypesError: 'Nie udało się pobrać listy typów wizyt',
    getVisitTimesError: 'Nie udało się pobrać listy godzin wizyt',
    bookAppointmentError: 'Nie udało się zarezerwować wizyty',
  },
  messages: {
    noDataAvailable: 'Brak elementów',
    addPet: 'Dodaj nowego zwierzaka klikając w przycisk \'+\'',
    choosePet: 'Wybierz zwierzaka...',
    chooseOrAddPet: 'Wybierz zwierzaka lub dodaj nowego klikając w przycisk \'+\'',
  },
  button: {
    cancel: 'Anuluj',
    add: 'Dodaj',
    save: 'Zapisz',
    no: 'Nie',
    yes: 'Tak',
    clear: 'Wyczyść',
    back: 'Wstecz',
    next: 'Dalej',
    send: 'Wyślij',
    return: 'Powrót',
  },
  header: {
    planVisit: 'Zaplanuj wizytę',
    profile: 'Mój profil',
    pets: 'Moje zwierzaki',
    logout: 'Wyloguj',
  },
  profile: {
    form: {
      name: 'Imię*',
      surname: 'Nazwisko*',
      phone: 'Telefon*',
      street: 'Adres*',
      city: 'Miasto*',
      zipCode: 'Kod pocztowy*',
      country: 'Państwo*',
    },
  },
  pets: {
    form: {
      newPet: 'Nowy zwierzak',
      editPet: 'Edycja zwierzaka',
      name: 'Imię*',
      species: 'Gatunek*',
      race: 'Rasa*',
      sex: 'Płeć*',
      birthDate: 'Data urodzenia*',
      weight: 'Waga*',
      weightSuffix: 'kg',
      microchip: 'Mikrochip',
      passport: 'Paszport',
      sterilized: 'wysterylizowana',
      castrated: 'Wykastrowany',
    },
    delete: {
      title: 'Usuwanie zwierzaka',
      description: 'Czy na pewno chcesz usunąć wybranego zwierzaka?',
    },
  },
  register: {
    title: 'Rejestracja',
    register: 'Zarejestruj',
    password: 'Hasło',
    repeatPassword: 'Powtórz hasło',
    acceptRules: 'Przeczytałem(-am) i akceptuję Zasady ochrony danych osobowych i korzystania z plików cookie zawarte w',
    termsOfUse: 'Regulaminie',
  },
  resetPassword: {
    title: 'Resetowanie hasła',
    subtitle: 'Aby kontynuować resetowanie hasła, wprowadź poniżej swój adres e-mail',
  },
  visits: {
    stepper: {
      firstStep: 'Uzupełnij dane profilowe',
      secondStep: 'Wybierz zwierzaka',
      thirdStep: 'Wybierz termin i typ wizyty',
    },
  },
  appointment: {
    visitType: 'Wybierz typ wizyty...',
    date: 'Wybierz datę wizyty...',
    description: 'Krótki opis wizyty',
    afterTwelve: 'Od 12:00',
    beforeSixteenth: '12:00 - 16:00',
    afterSixteenth: 'Od 16:00',
    noAppointments: 'Brak  terminów',
    summary: 'Dziękujemy za dokonanie rezerwacji. Informacja o potwierdzeniu wizyty zostanie wysłana na podany adres e-mail.',
  },
}
